import lazyPage from '@monorepo/core/hoc/lazyPage'

export default () => [
  {
    component: lazyPage(() =>
      import('App/View/Errors').then(({ Error404 }) => Error404)
    ),
  },
]
